/**
 * 
 * @param {string} value 
 * @returns {string}
 */
export const removeInvalidChar = value => {
    return value.replace(/[^\d]+/g, '')
}